'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoAndroidFolder = function IoAndroidFolder(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm14.1 7.5l3.4 3.8h14.1c1.8 0 3.4 1.5 3.4 3.3v14.5c0 1.8-1.6 3.4-3.4 3.4h-28.2c-1.8 0-3.4-1.6-3.4-3.4v-18.2c0-1.8 1.6-3.4 3.4-3.4h10.7z' })
        )
    );
};

exports.default = IoAndroidFolder;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/android-folder.js
// module id = 2345
// module chunks = 168707334958949